import React from "react";
import styles from "./ErrorPage.module.css";
import Button from "../components/Button";
import brain from "../static/images/component_svg/brain.svg";

function ErrorPage(props) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.body}>
        <div className={styles.header}>
          <img className={styles.img} src={brain} alt="brain"></img>
          <h1 className={styles.h1}>
            <div className={styles.err}>
              ขออภัยในความไม่สะดวก             
            </div>
            <div className={styles.errSub}>
              เว็บไซต์อยู่ระหว่างการปรับปรุงเพื่อพัฒนาระบบ
              <br/> 
              เนื่องจากมีผู้เข้าใช้งานพร้อมกันเป็นจำนวนมาก
            </div>
            เราจะกลับมาให้บริการอีกครั้งเร็วๆนี้
          </h1>
        </div>
      </div>
    </div>
  );
}

export default ErrorPage;
